//#region src/components/widget/language-pair/locale/en_US.ts
var e = { emptyText: "Not set" };
//#endregion
export { e as languagePairLocale };

//# sourceMappingURL=en_US.js.map